import * as types from '@/store/mutationTypes';

export const mutations = {
    [types.SET_PAYMENT_METHODS](state, methods) {
        state.methods = methods;
    },
    [types.SET_CLIENT_SECRET](state, clientSecret) {
        state.clientSecret = clientSecret;
    },
    [types.SET_PAYMENT_PAYLOAD](state, paymentPayload) {
        state.paymentPayload = paymentPayload;
    },
    [types.SET_IS_CLEANING_IN_PROGRESS](state, isCleaningInProgress) {
        state.isCleaningInProgress = isCleaningInProgress;
    },
    [types.SET_PAY_NOW_ACTIVITY_ID](state, payNowActivityId) {
        state.payNowActivityId = payNowActivityId;
    },
    [types.SET_INVOICE_DATA](state, invoiceData) {
        state.invoiceData = invoiceData;
    },
    [types.SET_COUPONS](state, coupons) {
        state.coupons = coupons;
    },
    [types.SET_PAY_NOW_ENROLLMENT_DATA](state, payNowEnrollmentData) {
        state.payNowEnrollmentData = payNowEnrollmentData;
    },
    [types.SET_IS_PAYMENT_METHODS_LOADING](state, isPaymentMethodsLoading) {
        state.isPaymentMethodsLoading = isPaymentMethodsLoading;
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/payment/mutations.js